export enum AuthEvent {
    LOGOUT = 'logout',
}
